export default __webpack_public_path__ + "static/FooterLogo-4d0881c7c6107306bf848b642b284809.webp";